export const CHECKOUT_REQUEST_STARTED = 'CHECKOUT_REQUEST_STARTED';
export const CHECKOUT_REQUEST_SUCCEEDED = 'CHECKOUT_REQUEST_SUCCEEDED';

export const CHECKOUT_PREPARATION_STARTED = 'CHECKOUT_PREPARATION_STARTED';
export const CHECKOUT_PREPARATION_SUCCEEDED = 'CHECKOUT_PREPARATION_SUCCEEDED';
export const CHECKOUT_PREPARATION_FAILED = 'CHECKOUT_PREPARATION_FAILED';
export const CHECKOUT_PREPARATION_SKIPPED = 'CHECKOUT_PREPARATION_SKIPPED';
